/* eslint-disable no-undef */
/**
 * site-scripts.js
 *
 * All general site scripts
 */

import Swiper from 'swiper/bundle';
import { groupEventListener } from './utils';



(function ($) {
	// Header Events

	const body = document.body;
	$(document).on('ready', function () {
		// Replace any href="#" links with href="javascript:void(0)"
		if (document.body.contains(document.querySelector('[href="#"]'))) {
			const emptyHrefs = Array.prototype.slice.call(
				document.querySelectorAll('[href="#"]')
			);
			emptyHrefs.forEach((link) => {
				link.href = 'javascript:void(0)';
			});
		}

		// Add .js-subnav-toggle class to any mobile nav items with children
		if (
			document.body.contains(
				document.querySelector('.menu-item-has-children')
			)
		) {
			const topLevelItems = Array.prototype.slice.call(
				document.querySelectorAll('.menu-item-has-children')
			);
			topLevelItems.forEach((item) => {
				item.classList.add('js-subnav-toggle');
			});
		}

		// If .sub-menu exists
		if (document.body.contains(document.querySelector('.sub-menu'))) {
			groupEventListener(
				'click',
				document.querySelectorAll('.js-subnav-toggle'),
				toggleSubMenu
			);
		}

		if (document.querySelector('.js-play')) {
			document
				.querySelector('.js-play')
				.addEventListener('click', toggleVideo);
			document
				.querySelector('.btn--play')
				.addEventListener('click', togglePlay);
		}

		if (
			document.body.contains(document.querySelector('.js-modal')) ||
			document.body.classList.contains('search')
		) {
			groupEventListener(
				'click',
				document.querySelectorAll('.js-modal'),
				toggleModal
			);
			groupEventListener(
				'click',
				document.querySelectorAll('.js-close-modal'),
				closeModal
			);
		}
	});

	if (document.body.contains(document.querySelector('.hamburger'))) {
		document
			.querySelector('.hamburger')
			.addEventListener('click', openMobileNav);
		document
			.querySelector('.header--mobile .btn--close')
			.addEventListener('click', closeMobileNav);
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('click', toggleAriaExpanded);
			});
	} else {
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('mouseover', toggleAriaExpanded);
			});
		document
			.querySelectorAll('.aria-expanded-toggle')
			.forEach(function (item) {
				item.addEventListener('mouseout', toggleAriaExpanded);
			});
	}

	// Expand Module

	groupEventListener(
		'click',
		document.querySelectorAll('.js-expand'),
		expandModule
	);
	groupEventListener(
		'click',
		document.querySelectorAll('.js-toggle-list'),
		toggleList
	);

	function openMobileNav() {
		document.querySelector('.header--mobile').classList.add('-is-open');
		document.querySelector('.btn--close').focus();
		document.querySelector('body').classList.add('-hide-page-overflow');
	}

	function closeMobileNav() {
		document.querySelector('.header--mobile').classList.remove('-is-open');
		document.querySelector('body').classList.remove('-hide-page-overflow');
	}

	function toggleSubMenu() {
		this.classList.toggle('active');
	}

	function toggleAriaExpanded() {
		const expanded =
			this.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
		this.setAttribute('aria-expanded', expanded);
	}

	function toggleModal() {
		const modalType = this.dataset.modal;
		document
			.querySelector('[data-modal-window="'.concat(modalType, '"]'))
			.classList.add('active');
		document.body.classList.add('-hide-page-overflow');
	}

	function closeModal() {
		const modalType = this.dataset.modalClose;
		document
			.querySelector('[data-modal-window="'.concat(modalType, '"]'))
			.classList.remove('active');
		document.body.classList.remove('-hide-page-overflow');
	}

	function addModalCloseEvent(modal) {
		window.onclick = function (event) {
			if (event.target === modal) {
				modal.classList.remove('active');
				document.body.classList.remove('-hide-page-overflow');
			}
		};
	}





// Request Homepage Material Modal

// Modal
var Modal = (function() {
	var openedModal;
  
	return {
	  open,
	  close
	};
  
	function open(target, callback) {
	  document.documentElement.classList.add("is-scroll-disabled");
	  openedModal = document.querySelector(target);
	  openedModal.dataset.opened = "true";
	  callback && callback(openedModal);
  
  
	  // Add iframe src
	  if (openedModal.dataset.iframe) {
		openedModal.querySelector("iframe").src = openedModal.dataset.iframe;
	  }
	}
  
	function close(event, callback) {
	  if (event) {
		event.preventDefault(), event.stopPropagation();
		if (!event.target.dataset.hasOwnProperty("modalClose")) return;
	  }
  
	  document.documentElement.classList.remove("is-scroll-disabled");
	  openedModal.dataset.opened = "false";
  
	  // Remove video iframe url or iframe src
	  if (openedModal.dataset.iframe) {
		openedModal.querySelector("iframe").src = "";
	  }
  
	  // Remove video iframe src or video src
	  if (openedModal.dataset.video) {
		if (openedModal.dataset.video.includes("youtube")) {
		  openedModal.querySelector("iframe").src = "";
		} else {
		  var video = openedModal.querySelector("video");
		  video.pause();
		  video.currentTime = 0;
		}
	  }
  
	  callback && callback(openedModal);
	}
  
	function change(target, event) {
	  event && (event.preventDefault(), event.stopPropagation());
	  openedModal.dataset.opened = "false";
	  openedModal = document.querySelector(target);
	  openedModal.dataset.opened = "true";
	}
  
  
  })();
  
  







/* Homepage Main SwiperJS */


var swiper1 = new Swiper(".full---width-swiper", {
	navigation: {
	  nextEl: ".swiper-next-button",
	  prevEl: ".swiper-prev-button" },
		  autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		  },
		   scrollbar: {
	  el: '.swiper-scrollbar',
	  draggable: true,
	},
	effect: "fade",
	loop: "infinite",
	pagination: {
	  el: ".swiper-pagination",
	  type: "fraction" } });
  
  
  
  swiper.on('slideChange', function (sld) {
	document.body.setAttribute('data-sld', sld.realIndex);
  });
  
  
// Smooth Scroll on about page
function scrollNav() {
	$('.nav a').click(function(){
	  $(".active").removeClass("active");     
	  $(this).addClass("active");
	  
	  $('html, body').stop().animate({
		scrollTop: $($(this).attr('href')).offset().top - 160
	  }, 300);
	  return false;
	});
  }
  scrollNav();



// WPForms Modal - Request Material Samples Homepage

$("#modal-materials > section > div > div > a").click(() =>
    $("#wpforms-form-8441").submit()
  );




// Homepage Locomotive Featured Projects

! function(o, c) {
	var n = c.documentElement,
		t = " w-mod-";
	n.className += t + "js", ("ontouchstart" in o || o.DocumentTouch && c instanceof DocumentTouch) && (n.className += t + "touch")
}(window, document);















	// Expandable Modules:
	// 1. Features Module

	function expandModule() {
		const openToggle = document.querySelector('.-is-expanded');
		if (openToggle && openToggle !== this) {
			openToggle.classList.remove('-is-expanded');
		}
		this.classList.toggle('-is-expanded');
	}

	if (document.body.classList.contains('page-template-page-membership')) {
		document.addEventListener(
			'click',
			function (event) {
				if (event.target.closest('.js-expand')) return;
				document
					.querySelector('.-is-expanded')
					.classList.remove('-is-expanded');
			},
			false
		);
	}

	// Toggle List

	function toggleList() {
		document.querySelector('.list-expand').classList.toggle('-is-expanded');
	} // Animations

	if (document.body.contains(document.querySelector('.copy__heading'))) {
		const speed = 40;
		const heading = document.querySelector('.copy__heading');
		const delay = heading.innerHTML.length * speed + speed;
	}

	function typeEffect(element, speed) {
		const text = element.innerHTML;
		element.innerHTML = '';
		let i = 0;
		const timer = setInterval(function () {
			if (i < text.length) {
				element.append(text.charAt(i));
				i++;
			} else {
				clearInterval(timer);
			}
		}, speed);
	}







	// Mailchimp Newsletter Form
	$('#mc_mv_EMAIL').attr('placeholder', $('label.mc_header_email').html());
	$('label.mc_header_email').hide();
	$('.mc_email_format').parent().hide();

	


	// Digital Services



	/*
	* slide-nav
	* ES6 Vanilla.js navigation plugin to simple use on one-page websites.
	* https://github.com/qmixi/slide-nav
	*
	* A project by Piotr Kumorek
	* Released under the MIT license.
	*/

	window.slide = new SlideNav();

	var $window = $(window);
	var distance = $('.slide-wrapper').offset().top;
	var wrapperHeight = $('.slide-wrapper').height();
	$window.scroll(function() {
		if ( $window.scrollTop() >= distance - 100 && $window.scrollTop() <= distance + wrapperHeight - 300 ) {
			$('.pagination').fadeIn();
		}
		else {
			$('.pagination').fadeOut();
		}
	});
			




/// Footer byline
	function insertByline() {
		const toInsert =
			'<br>Made by <a href="https://sixtyfivedesign.com/" target="_blank">Sixty Five Design</a>.';
		$('.footer-text .copyright').after(toInsert);
	}
	insertByline();
})(jQuery);
